var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityLearningExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619",
    transform: "translate(-784 -1752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(784 1752)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(784.625 1751.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(23.637 23.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M208.717,204.161a4.549,4.549,0,1,0,4.549,4.549A4.555,4.555,0,0,0,208.717,204.161Zm0,7.9a3.354,3.354,0,1,1,3.354-3.354A3.359,3.359,0,0,1,208.717,212.064Z",
    transform: "translate(-199.851 -199.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M171.67,161.494H171a7.514,7.514,0,0,0-.434-1.036l.474-.467a1.086,1.086,0,0,0,0-1.536l-1.776-1.774a1.118,1.118,0,0,0-1.539,0l-.459.474a7.282,7.282,0,0,0-1.036-.433v-.669A1.084,1.084,0,0,0,165.116,155h-2.51a1.084,1.084,0,0,0-1.114,1.054v.67a7.956,7.956,0,0,0-1.036.433l-.466-.473a1.136,1.136,0,0,0-1.536,0l-1.773,1.775a1.09,1.09,0,0,0,0,1.539l.474.46a7.917,7.917,0,0,0-.433,1.036h-.671A1.084,1.084,0,0,0,155,162.609v2.51a1.083,1.083,0,0,0,1.054,1.114h.669a7.375,7.375,0,0,0,.434,1.036l-.474.467a1.088,1.088,0,0,0,0,1.536l1.774,1.772a1.1,1.1,0,0,0,1.54,0l.46-.473a7.444,7.444,0,0,0,1.036.433v.67a1.083,1.083,0,0,0,1.114,1.054h2.51a1.074,1.074,0,0,0,1.087-1.071v-.661a7.244,7.244,0,0,0,1.05-.429l.473.475a1.116,1.116,0,0,0,1.539,0l1.774-1.773a1.091,1.091,0,0,0,0-1.54l-.473-.472a7.237,7.237,0,0,0,.433-1.05h.652a1.075,1.075,0,0,0,1.072-1.088v-2.51A1.084,1.084,0,0,0,171.67,161.494Zm-.086,3.518h-.714a1.015,1.015,0,0,0-.966.714,6.023,6.023,0,0,1-.453,1.092,1,1,0,0,0,.174,1.184l.5.5-1.625,1.624-.5-.5a1.022,1.022,0,0,0-1.182-.176,6.014,6.014,0,0,1-1.094.452,1.009,1.009,0,0,0-.714.97v.714h-2.288v-.723a1,1,0,0,0-.716-.96,6.281,6.281,0,0,1-1.1-.454,1.02,1.02,0,0,0-1.18.178l-.5.5L157.6,168.5l.5-.5a1,1,0,0,0,.178-1.178,6.245,6.245,0,0,1-.454-1.1,1,1,0,0,0-.96-.718h-.723v-2.282h.723a1,1,0,0,0,.96-.713,6.392,6.392,0,0,1,.456-1.106,1,1,0,0,0-.179-1.178l-.5-.5,1.625-1.625.5.5a1.024,1.024,0,0,0,1.178.178,6.424,6.424,0,0,1,1.107-.455,1,1,0,0,0,.713-.96v-.723H165v.723a1,1,0,0,0,.718.961,6.175,6.175,0,0,1,1.1.452A1.021,1.021,0,0,0,168,158.1l.5-.5,1.625,1.625-.5.5a1,1,0,0,0-.178,1.178,6.253,6.253,0,0,1,.454,1.1,1,1,0,0,0,.96.716h.724Z",
    transform: "translate(-154.998 -155)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(11 11.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M17.979,191.763a3.115,3.115,0,1,0-3.518,0c-2.037.459-3.461,1.7-3.461,3.2,0,1.9,2.293,3.389,5.22,3.389s5.221-1.489,5.221-3.389c0-1.5-1.425-2.74-3.462-3.2Zm-1.759-4.49a1.921,1.921,0,1,1-1.92,1.921A1.923,1.923,0,0,1,16.22,187.273Zm0,9.884c-2.145,0-4.026-1.026-4.026-2.2s1.881-2.2,4.026-2.2,4.026,1.026,4.026,2.2S18.365,197.157,16.22,197.157Z",
    transform: "translate(-11 -170.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M203.488,16.686a3.115,3.115,0,1,0-3.517,0c-2.037.459-3.462,1.7-3.462,3.2,0,1.9,2.293,3.389,5.221,3.389s5.22-1.489,5.22-3.389C206.95,18.386,205.525,17.145,203.488,16.686ZM201.73,12.2a1.921,1.921,0,1,1-1.92,1.921,1.923,1.923,0,0,1,1.92-1.921Zm0,9.883c-2.145,0-4.026-1.026-4.026-2.2s1.881-2.2,4.026-2.2,4.026,1.026,4.026,2.2S203.874,22.079,201.73,22.079Z",
    transform: "translate(-180.23 -11.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M203.488,366.842a3.115,3.115,0,1,0-3.518,0c-2.037.459-3.462,1.7-3.462,3.2,0,1.9,2.293,3.389,5.221,3.389s5.22-1.489,5.22-3.389C206.95,368.542,205.525,367.3,203.488,366.842Zm-1.759-4.49a1.921,1.921,0,1,1-1.92,1.921,1.923,1.923,0,0,1,1.92-1.921Zm0,9.883c-2.145,0-4.026-1.026-4.026-2.2s1.881-2.2,4.026-2.2,4.026,1.026,4.026,2.2S203.874,372.235,201.73,372.235Z",
    transform: "translate(-180.23 -330.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M389,191.762a3.115,3.115,0,1,0-3.518,0c-2.037.459-3.462,1.7-3.462,3.2,0,1.9,2.293,3.389,5.22,3.389s5.221-1.489,5.221-3.389C392.461,193.463,391.036,192.221,389,191.762Zm-1.759-4.49a1.921,1.921,0,1,1-1.92,1.921A1.923,1.923,0,0,1,387.24,187.272Zm0,9.884c-2.145,0-4.026-1.026-4.026-2.2s1.881-2.2,4.026-2.2,4.026,1.026,4.026,2.2S389.385,197.156,387.24,197.156Z",
    transform: "translate(-349.461 -170.714)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(16.523 15.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M89.237,64.346,86.816,63.7a.6.6,0,0,0-.309,1.154l.972.26a18.006,18.006,0,0,0-6.063,5.927.6.6,0,0,0,1.012.634A16.809,16.809,0,0,1,88.148,66.1l-.291,1.085a.6.6,0,1,0,1.154.309l.649-2.421a.6.6,0,0,0-.422-.731Z",
    transform: "translate(-80.677 -63.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M344.046,75.51a.6.6,0,0,0-.731.422l-.235.877a17.987,17.987,0,0,0-6.745-5.675.6.6,0,0,0-.522,1.075,16.792,16.792,0,0,1,6.365,5.395l-1.2-.322a.6.6,0,0,0-.309,1.154l2.421.649a.6.6,0,0,0,.731-.423l.648-2.421A.6.6,0,0,0,344.046,75.51Z",
    transform: "translate(-312.524 -70.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M343.55,354.106a.6.6,0,0,0-.823.19,16.807,16.807,0,0,1-5.718,5.568l.291-1.086a.6.6,0,1,0-1.154-.309l-.649,2.421a.6.6,0,0,0,.422.731l2.421.648a.6.6,0,0,0,.309-1.154l-.972-.26a18,18,0,0,0,6.062-5.927A.6.6,0,0,0,343.55,354.106Z",
    transform: "translate(-312.525 -328.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M82.6,360.5a16.79,16.79,0,0,1-6-4.9l.844.226a.6.6,0,0,0,.309-1.154l-2.421-.648a.6.6,0,0,0-.731.422l-.649,2.421a.6.6,0,1,0,1.154.309l.311-1.161a17.988,17.988,0,0,0,6.659,5.556A.6.6,0,0,0,82.6,360.5Z",
    transform: "translate(-73.934 -328.533)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityLearningExperience);
export default __webpack_public_path__ + "static/media/quality-learning-experience.4de24a25a695c2bfa4a0a90f7d13308a.svg";
export { ForwardRef as ReactComponent };